(ns hai.datetime)

;; js/undefined defaults to the user's system locale
(def system-locale js/undefined)

(def ^:private time-formatter
  (js/Intl.DateTimeFormat. system-locale #js {:hour "numeric" :minute "2-digit"}))

(def ^:private date-formatter
  (js/Intl.DateTimeFormat. system-locale #js {:weekday "long" :month "long" :day "numeric" :year "numeric"}))

;; Today's date as a card title: weekday, day and month, no year. The short
;; form stands in where the long one would wrap.
(def ^:private date-label-formatter
  (js/Intl.DateTimeFormat. system-locale #js {:weekday "long" :day "numeric" :month "long"}))

(def ^:private date-label-short-formatter
  (js/Intl.DateTimeFormat. system-locale #js {:weekday "short" :day "numeric" :month "short"}))

(defn format-time [d]
  (.format time-formatter d))

(defn format-date [d]
  (.format date-formatter d))

(defn format-date-label [d]
  (.format date-label-formatter d))

(defn format-date-label-short [d]
  (.format date-label-short-formatter d))

(defn- part-pairs [d]
  (mapv (juxt #(keyword (.-type %)) #(.-value %))
        (.formatToParts time-formatter d)))

;; The locale's glue between the numbers, keyed by the part each piece follows:
;; a colon after the hour (a period in Danish and Finnish) and, in 12-hour
;; locales, a space after the minute. Fixed for the session, so read once.
(def ^:private literal-after
  (into {}
        (for [[[left-type] [right-type right-value]] (partition 2 1 (part-pairs (js/Date.)))
              :when (= :literal right-type)]
          [left-type right-value])))

(def time-separator (:hour literal-after))
(def day-period-separator (:minute literal-after))

(defn time-parts [d]
  (let [by-type (into {} (part-pairs d))]
    {:hour       (:hour by-type)
     :minute     (:minute by-type)
     :day-period (:dayPeriod by-type)}))

(defn format-hour-recognizable [h]
  (let [[hour literal1 minute literal2 day-period] (->> (doto (js/Date.) (.setHours h 0 0 0))
                                                        (.formatToParts time-formatter)
                                                        (map #(some-> % .-value)))]
    ^{:key h} [:span hour (if day-period
                            [:span literal2 day-period]
                            [:small literal1 minute])]))
